import Vue from 'vue';
import App from './App';
// import { store } from './store';
import Helpers from '@/tools/Helpers';
import VueScrollTo from 'vue-scrollto';
import VueMask from 'v-mask'
import "./assets/scss/app.scss";

Vue.use(VueScrollTo, {
    container: "body",
    duration: 2000,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.use(VueMask);

Vue.config.productionTip = false;

new Vue({
    el: '#app',
    // store,
    template: '<App/>',
    data() {
        return {
            Helpers,
        }
    },
    created() {
        window.vue = this;
    },
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js